export const defaultCompanyData: any = {
  id: '',
  name: '',
  description: '',
  header: '',
  url: '',
  region: '',
  isActive: false,
  orderNo: 0
}
